import React, { useEffect, useState } from 'react'
import { Col, Modal, Row, Form } from 'react-bootstrap'
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import ReactSelect from "react-select";
import { customStyles } from "../../selectStyles";
import { useDispatch, useSelector } from 'react-redux';
import { fetchLanguage } from '../../redux/actions/LanguageAction';
import axios from '../../API/axios';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
const UpdateLangugae = ({ setLanguageModal, languageModal, userDataId, getUserCv, userDataInfo }) => {

    // ...............................language DDL.......................................
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();
    const dispatch = useDispatch();
    
    const [language, setLanguage] = useState([]);
    const { LanguageList, selectedLanguageId } = useSelector(
        (state) => state.language
    );
    console.log("language", LanguageList);

    useEffect(() => {
        dispatch(fetchLanguage());
    }, [dispatch]);

    const handleLanguageSelect = (selectedOption) => {
        setLanguage(selectedOption);

    };
    // ...............................language DDL.......................................
    const multiLang = language.map((option) => option.value).join(",");
    // console.log("multiLang:", multiLang);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const body = {
            sessionId: sessionId,
            userDataId: userDataId,
            userType: userType,
            instnCnddtID: CandidateId === 'Candidate' ? null : CandidateId,
            langIDs: Array.isArray(multiLang)
                ? multiLang.flatMap(lang => lang.split(',').map(Number)) // Convert to an array of numbers
                : multiLang.split(',').map(Number) // Handle single string input
        };
        console.log("update body", body);

        try {
            const res = await axios.post("/Resume/UpdateLanguages", body);
            console.log("updateres=====>", res);

            toast.success(res.data.message);
            setLanguageModal(false);
            setLanguage([])
            getUserCv();
        } catch (error) {
            if (error.response && error.response.status === 404) {
                toast.warning(error.response.data.message);
            } else {
                toast.error(error.response?.data?.message || "An error occurred");
            }
        }
    };

    return (
        <>
            <Modal show={languageModal} onHide={() => { setLanguageModal(false) }} centered size="md">
                <Modal.Header >
                    <Modal.Title>Update Language</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={() => { setLanguageModal(false) }} />
                </Modal.Header>
                <Modal.Body className="settings">
                    <Row>
                        <Col md={12}>
                            <Form.Group controlId="city">
                                <Form.Label className="class-type">
                                    Language
                                </Form.Label>
                                <div className="post-form-group">
                                    <input
                                        type="text"
                                        value={userDataInfo?.languages?.join(", ")}
                                        placeholder="Enter Institute name"
                                        className="mb-2 form-control Dark-Input-from-group"
                                        disabled
                                    />

                                    <ReactSelect
                                        options={LanguageList}
                                        onChange={handleLanguageSelect}
                                        value={language}
                                        placeholder="Select Language"
                                        classNamePrefix="react-select"
                                        className="form-control Dark-Input-from-group"
                                        styles={customStyles}
                                        isMulti
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="add-class-submit-button mt-4 d-flex justify-content-center">
                        <div className="khojPrimaryBtn ms-3">
                            <a href="#/" className=""
                                onClick={handleSubmit}
                            >
                                Update
                            </a>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdateLangugae